module.exports = __webpack_public_path__ + "static/media/jacket-3.21302ce0.jpg";